"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProductTax = exports.calculateSalesTaxTotal = exports.calculateProductTotal = exports.calculatePriceSummary = exports.QuoteContactRoles = exports.QuoteContactRole = void 0;
const currency_math_1 = require("./currency-math");
var QuoteContactRole;
(function (QuoteContactRole) {
    QuoteContactRole["Agent"] = "Agent";
    QuoteContactRole["PrimaryBeneficiary"] = "Primary Beneficiary";
    QuoteContactRole["ContingentBeneficiary"] = "Contingent Beneficiary";
    QuoteContactRole["Insured"] = "Insured";
    QuoteContactRole["Purchaser"] = "Purchaser";
})(QuoteContactRole = exports.QuoteContactRole || (exports.QuoteContactRole = {}));
exports.QuoteContactRoles = Object.values(QuoteContactRole);
function calculatePriceSummary(products, taxRate) {
    const subtotal = calculateProductTotal(products);
    const tax = calculateSalesTaxTotal(products, taxRate);
    return {
        subtotal,
        tax,
        total: subtotal + tax,
    };
}
exports.calculatePriceSummary = calculatePriceSummary;
function calculateProductTotal(products) {
    const total = products.reduce((total, product) => {
        return currency_math_1.add(total, currency_math_1.multiply(product.price, product.quantity));
    }, 0);
    return currency_math_1.round(total);
}
exports.calculateProductTotal = calculateProductTotal;
function calculateSalesTaxTotal(products, taxRate) {
    const total = products.reduce((total, product) => {
        return currency_math_1.add(total, calculateProductTax(product, taxRate));
    }, 0);
    return currency_math_1.round(total);
}
exports.calculateSalesTaxTotal = calculateSalesTaxTotal;
function calculateProductTax(product, taxRate) {
    if (product.explicitSalesTax > 0) {
        return currency_math_1.multiply(product.explicitSalesTax, product.quantity);
    }
    if (product.includeSalesTax) {
        return currency_math_1.multiply(taxRate, currency_math_1.multiply(product.price, product.quantity));
    }
    return 0;
}
exports.calculateProductTax = calculateProductTax;
//# sourceMappingURL=quote-total.js.map